/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgNote32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        d='M11 17.75h16v-1.5H11v1.5zM27 21.75H11v-1.5h16v1.5zM11 25.75h6v-1.5h-6v1.5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M6.309 4.25a4.751 4.751 0 019.382 0h3.618a4.751 4.751 0 019.382 0H29A2.75 2.75 0 0131.75 7v22A2.75 2.75 0 0129 31.75H3A2.75 2.75 0 01.25 29V7A2.75 2.75 0 013 4.25h3.309zm1.528 0a3.251 3.251 0 016.326 0H7.837zM24 1.75a3.251 3.251 0 013.163 2.5h-6.326A3.251 3.251 0 0124 1.75zm-8.309 4h11.472A3.251 3.251 0 0124 8.25a.75.75 0 000 1.5 4.751 4.751 0 004.691-4H29c.69 0 1.25.56 1.25 1.25v4.25H7.75V7c0-.69.56-1.25 1.25-1.25h5.163A3.251 3.251 0 0111 8.25a.75.75 0 000 1.5 4.751 4.751 0 004.691-4zm-12.141 0H3c-.69 0-1.25.56-1.25 1.25v22c0 .69.56 1.25 1.25 1.25h.55c-.192-.375-.3-.8-.3-1.25V7c0-.45.108-.875.3-1.25zM6 30.25c-.69 0-1.25-.56-1.25-1.25V7c0-.69.56-1.25 1.25-1.25h.55c-.192.375-.3.8-.3 1.25v22c0 .45.108.875.3 1.25H6zM7.75 29c0 .69.56 1.25 1.25 1.25h20c.69 0 1.25-.56 1.25-1.25V12.75H7.75V29z'
      />
    </svg>
  );
}

export default SvgNote32;
